import { render, staticRenderFns } from "./AscColorChipRenderer.vue?vue&type=template&id=7df7e936&scoped=true"
import script from "./AscColorChipRenderer.vue?vue&type=script&lang=js"
export * from "./AscColorChipRenderer.vue?vue&type=script&lang=js"
import style0 from "./AscColorChipRenderer.vue?vue&type=style&index=0&id=7df7e936&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df7e936",
  null
  
)

export default component.exports